import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        ids: null,
        idList: null,
        roleIdList: null,
        roleList: null,
        storeList: null
    },
    mutations: {
        setids(state, data) {
            state.ids = data
        },
        setidList(state, data) {
            state.idList = data
        },
        setroleIdList(state, data) {
            state.roleIdList = data
        },
        setroleList(state, data) {
            state.roleList = data
        },
        setStoreList(state, data){
            state.storeList = data
        }
    },
    actions: {},
})


// WEBPACK FOOTER //
// ./src/store/index.js